"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Form/RadioInput.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);










 const RadioOption = ({
  label, selected, disabled, onClick, className,
}) => {
  const rootClassName = _classBuilder2.default.call(void 0, 
    "blm-form--radio-input--option",
    selected && "selected",
    className,
  )

  // Space and Enter select, as they would on a native radio.
  const onKeyDown = (e) => {
    if (e.key !== ' ' && e.key !== 'Enter') return
    e.preventDefault()
    _optionalChain([onClick, 'optionalCall', _ => _()])
  }

  return (
    _react2.default.createElement('div', {
      role: "radio",
      'aria-checked': !!selected,
      'aria-disabled': disabled || undefined,
      tabIndex: disabled ? -1 : 0,
      className: rootClassName,
      onClick: onClick,
      onKeyDown: onKeyDown, __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}

      , _react2.default.createElement('span', { className: "blm-form--radio-input--option--circle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}})
      , _react2.default.createElement('span', { className: "blm-form--radio-input--option--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}, label)
    )
  )
}; exports.RadioOption = RadioOption






















const RadioInputView = ({
  options, label, className, disabled, selectedValue, onSelect,
}) => {
  const rootClassName = 'blm-form--input blm-form--radio-input ' +
    (disabled ? 'blm-form--disabled ' : '') +
    className
  const optionsElements = options.map((o) => (
    _react2.default.createElement(exports.RadioOption, {
      key: String(o.value),
      value: o.value,
      label: o.label,
      selected: selectedValue === o.value,
      disabled: disabled,
      onClick: () => !disabled && onSelect(o.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}
    )
  ))

  return (
    _react2.default.createElement('div', { className: rootClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 85}}
      , label ? _react2.default.createElement('label', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 86}}, label) : null
      , _react2.default.createElement('div', { role: "radiogroup", className: "blm-form--radio-input--options-container", __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}}
        , optionsElements
      )
    )
  )
}

// Keeps its own selection, seeded from `value` on mount.
const RadioInput = (props) => {
  const { value, onChange, inputId } = props
  const [selectedValue, setSelectedValue] = _react.useState(value || '')

  const onSelect = (v) => {
    setSelectedValue(v)
    onChange(inputId, null, v)
  }

  return _react2.default.createElement(RadioInputView, { ...props, selectedValue: selectedValue, onSelect: onSelect, __self: this, __source: {fileName: _jsxFileName, lineNumber: 104}} )
}

// Selection follows the `value` prop: seeded like RadioInput, then synced
// whenever `value` changes (the class did this in componentDidUpdate).
// Selecting only reports the change; the parent owns the value.
 const ControlledRadioInput = (props) => {
  const { value, onChange, inputId } = props
  const [selectedValue, setSelectedValue] = _react.useState(value || '')
  const [prevValue, setPrevValue] = _react.useState.call(void 0, value)
  if (prevValue !== value) {
    setPrevValue(value)
    setSelectedValue(value)
  }

  const onSelect = (v) => {
    onChange(inputId, null, v)
  }

  return (
    _react2.default.createElement(RadioInputView, {
      ...props,
      selectedValue: selectedValue,
      onSelect: onSelect, __self: this, __source: {fileName: _jsxFileName, lineNumber: 124}}
    )
  )
}; exports.ControlledRadioInput = ControlledRadioInput

exports. default = RadioInput
